import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: 'How quickly can I set up my AI agent?',
      answer: 'You can have your AI chatbot or voice agent up and running in less than 10 minutes. Our intuitive setup wizard guides you through the process, and you can customize responses, integrate with your tools, and deploy immediately.'
    },
    {
      question: 'What languages do your AI agents support?',
      answer: 'Our AI agents support over 50 languages including English, Spanish, French, German, Chinese, Japanese, Arabic, and many more. The system automatically detects the customer\'s language and responds accordingly.'
    },
    {
      question: 'Can I integrate with my existing CRM and tools?',
      answer: 'Yes! We offer pre-built integrations with popular platforms like Salesforce, HubSpot, Zendesk, Shopify, and more. You can also use our API to create custom integrations with any system.'
    },
    {
      question: 'How does the voice calling agent work?',
      answer: 'Our voice AI uses advanced speech recognition and natural language processing to understand spoken queries. It can make and receive calls, handle complex conversations, and seamlessly transfer to human agents when needed.'
    },
    {
      question: 'Is my customer data secure?',
      answer: 'Absolutely. We use bank-level encryption, are GDPR compliant, and SOC 2 certified. Your data is stored securely, and we never share it with third parties. You maintain full control and ownership of all customer interactions.'
    },
    {
      question: 'Can I upgrade or downgrade my plan anytime?',
      answer: 'Yes, you can change your subscription plan at any time. Upgrades take effect immediately, and downgrades apply at the start of your next billing cycle. There are no cancellation fees.'
    }
  ]

  return (
    <section data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="38:4" data-component-id="client/src/components/home/FAQSection.jsx:38:4" className="py-20 bg-gray-50">
      <div data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="39:6" data-component-id="client/src/components/home/FAQSection.jsx:39:6" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="40:8" data-component-id="client/src/components/home/FAQSection.jsx:40:8" className="text-center mb-16">
          <h2 data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="41:10" data-component-id="client/src/components/home/FAQSection.jsx:41:10" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="44:10" data-component-id="client/src/components/home/FAQSection.jsx:44:10" className="text-xl text-gray-600">
            Everything you need to know about our AI agents
          </p>
        </div>

        <div data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="49:8" data-component-id="client/src/components/home/FAQSection.jsx:49:8" className="space-y-4">
          {faqs.map((faq, index) => (
            <div data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="51:12" data-component-id="client/src/components/home/FAQSection.jsx:51:12"
              key={index}
              className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
            >
              <button data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="55:14" data-component-id="client/src/components/home/FAQSection.jsx:55:14"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <span data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="59:16" data-component-id="client/src/components/home/FAQSection.jsx:59:16" className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <ChevronDown data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="62:16" data-component-id="client/src/components/home/FAQSection.jsx:62:16"
                  className={`w-6 h-6 text-gray-500 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              {openIndex === index && (
                <div data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="70:16" data-component-id="client/src/components/home/FAQSection.jsx:70:16" className="px-6 pb-5">
                  <p data-component-path="client/src/components/home/FAQSection.jsx" data-component-line="71:18" data-component-id="client/src/components/home/FAQSection.jsx:71:18" className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQSection